import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  encapsulation: ViewEncapsulation.None
})
export class DashboardComponent  {
   
}



// WEBPACK FOOTER //
// E:/sachin/Project/Masterly_Solutions/Project_HRMS/Hrms_Developer/hrms/Peerless.HRMS.WebUI.EmployeePortal/src/app/pages/dashboard/dashboard.component.ts